module.exports = __webpack_public_path__ + "static/media/Policies_ExpertMFD.8135921a.pdf";